<div class="panel panel-default col-sm-5" style="margin-left: 100px; display: none" id="settingsLicensing">
  <div class="panel-heading">Licensing</div>

  <div class="panel-body">
    <form class="form-horizontal">

      <div class="form-group">
        <label class="control-label col-sm-4">License Email Addresses</label>
        <div class="col-sm-8"><input class="form-control" type="text" name="license_email_address" [(ngModel)]="license_email_address"></div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-4">Days Before Expiration</label>
        <div class="col-sm-8"><input class="form-control" type="text" name="license_email_days" [(ngModel)]="license_email_days"></div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-primary" (click)="updateSettingsLicensing()"><i class="fa fa-refresh" aria-hidden="true"></i> UPDATE</button>
      </div>
    </form>
  </div>

</div>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>
